

// import { useQuery } from "@tanstack/react-query";
// import {
//   Bar,
//   BarChart,
//   CartesianGrid,
//   ResponsiveContainer,
//   Tooltip,
//   XAxis,
//   YAxis,
// } from "recharts";
// import {
//   AlertCircle,
//   BarChart3,
//   Bot,
//   BookOpen,
//   CalendarCheck,
//   CalendarDays,
//   ChevronRight,
//   FileText,
//   Globe,
//   Inbox,
//   Kanban,
//   Layers,
//   Lightbulb,
//   Link2,
//   Linkedin,
//   Mail,
//   Megaphone,
//   MessageSquare,
//   PlayCircle,
//   Plus,
//   Reply,
//   Rocket,
//   Send,
  
//   Sparkles,
//   Target,
//   TrendingUp,
//   Users,
//   Users2,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "@/context/AuthContext";
// import {
//   http,
//   managerDashboardApi,
//   senderIdentityApi,
// } from "@/services/apiClient";
// import { ErrorState } from "@/components/ui/error-state";
// import { PageHeader } from "@/components/ui/page-header";
// import { StatCard } from "@/components/ui/stat-card";
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from "@/components/ui/card";
// import { Skeleton } from "@/components/ui/skeleton";
// import { Badge } from "@/components/ui/badge";
// import { Progress } from "@/components/ui/progress";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "@/components/ui/table";
// import { Button } from "@/components/ui/button";
// import { EmptyState } from "@/components/ui/empty-state";
// import { cn, formatCurrency, toProperCase } from "@/lib/utils";

// /* ── Local types ─────────────────────────────────────────────────────────── */

// interface ChecklistItem {
//   key: string;
//   label: string;
//   description: string;
//   link: string;
//   order: number;
//   done: boolean;
// }

// interface ChecklistData {
//   items: ChecklistItem[];
//   completed: number;
//   total: number;
//   all_done: boolean;
// }

// interface LlmConfig {
//   id: string;
//   name: string;
//   isActive: boolean;
//   isDefault: boolean;
// }

// interface DomainSummary {
//   id: string;
//   domain: string;
//   spfStatus?: boolean;
//   dkimStatus?: boolean;
//   dmarcStatus?: boolean;
// }

// interface SenderIdentity {
//   id: string;
//   email: string;
//   isDefault?: boolean;
// }

// /* ── Quick Actions definition ────────────────────────────────────────────── */

// const QUICK_ACTIONS = [
//   { label: "Add LLM Model",     path: "/setup/llm-models",            icon: Bot },
//   { label: "Manage Prompts",    path: "/setup/prompts",               icon: FileText },
//   { label: "Create ICP",        path: "/prospecting/icp-profiles",    icon: Target },
//   { label: "Add Prospect",      path: "/prospects",                   icon: Users },
//   { label: "Integrations",      path: "/setup/integrations",          icon: Link2 },
//   { label: "Run Autopilot",     path: "/prospecting/autopilot",       icon: Rocket },
//   { label: "Campaigns",         path: "/outreach/campaigns",          icon: Megaphone },
//   { label: "Generate Email",    path: "/outreach/email-studio",       icon: Sparkles },
//   { label: "Build Sequence",    path: "/outreach/sequences",          icon: Layers },
//   { label: "Setup Domain",      path: "/setup/domains",               icon: Globe },
//   { label: "Analytics",         path: "/optimize/analytics",          icon: BarChart3 },
//   { label: "Templates",         path: "/outreach/templates",          icon: BookOpen },
//   { label: "Track Deals",       path: "/pipeline/deals",              icon: Kanban },
//   { label: "Reply Inbox",       path: "/outreach/reply-inbox",        icon: Inbox },
//   { label: "LinkedIn Hub",      path: "/prospecting/linkedin",        icon: Linkedin },
//   { label: "Content Ideas",     path: "/optimize/content-ideas",      icon: Lightbulb },
//   { label: "Weekly Digest",     path: "/optimize/weekly-digest",      icon: CalendarDays },
// ] as const;

// /* ── Workflow steps definition ───────────────────────────────────────────── */

// const WORKFLOW_STEPS = [
//   { step: 1,  title: "Connect AI Model",       desc: "Set up your LLM provider",         path: "/setup/llm-models" },
//   { step: 2,  title: "Setup Domain",           desc: "Configure sending domain & DNS",   path: "/setup/domains" },
//   { step: 3,  title: "Configure Integrations", desc: "Connect MailBridge & data tools",  path: "/setup/integrations" },
//   { step: 4,  title: "Define ICP",             desc: "Create ideal customer profile",    path: "/prospecting/icp-profiles" },
//   { step: 5,  title: "Import Prospects",       desc: "Add & enrich your leads",          path: "/prospects" },
//   { step: 6,  title: "Run Autopilot",          desc: "AI GTM pipeline — 60 seconds",     path: "/prospecting/autopilot" },
//   { step: 7,  title: "Generate Emails",        desc: "AI copywriting & QA scoring",      path: "/outreach/email-studio" },
//   { step: 8,  title: "Build Sequence",         desc: "Multi-touch cadence",              path: "/outreach/sequences" },
//   { step: 9,  title: "Track Replies",          desc: "Manage inbox & AI drafts",         path: "/outreach/reply-inbox" },
//   { step: 10, title: "Close Deals",            desc: "Pipeline & revenue tracking",      path: "/pipeline/deals" },
// ] as const;

// /* ── Helpers ─────────────────────────────────────────────────────────────── */

// /**
//  * CASING FIX: explicit display labels for campaign status enum values.
//  * The backend returns lowercase strings (active, draft, paused, etc.).
//  */
// const CAMPAIGN_STATUS_LABEL: Record<string, string> = {
//   active: "Active",
//   draft: "Draft",
//   paused: "Paused",
//   completed: "Completed",
//   archived: "Archived",
// };

// function statusVariant(status: string): "default" | "secondary" | "destructive" | "outline" {
//   const s = status.toLowerCase();
//   if (s === "active") return "default";
//   if (s === "paused") return "secondary";
//   if (s === "draft") return "outline";
//   return "secondary";
// }

// function fmtPct(rate: number): string {
//   return `${(rate * 100).toFixed(1)}%`;
// }

// /* ══════════════════════════════════════════════════════════════════════════ */
// /*  Component                                                                */
// /* ══════════════════════════════════════════════════════════════════════════ */

// export function UserDashboardPage() {
//   const { initialized, isAuthenticated } = useAuth();
//   const navigate = useNavigate();

//   const queryEnabled = initialized && isAuthenticated;

//   const {
//     data: dashRaw,
//     isLoading: dashLoading,
//     isError: dashError,
//     error: dashErr,
//     refetch: refetchDash,
//   } = useQuery({
//     queryKey: ["dashboard", "me"],
//     queryFn: () => managerDashboardApi.mine(),
//     enabled: queryEnabled,
//     retry: (failureCount, err) => {
//       const status = (err as { response?: { status?: number } })?.response?.status;
//       if (status === 401 || status === 403) return false;
//       return failureCount < 1;
//     },
//   });

//   const { data: quotaData } = useQuery({
//     queryKey: ["email-quota", "me"],
//     queryFn: () => senderIdentityApi.myQuota(),
//     enabled: queryEnabled,
//   });

//   const { data: llmConfigsRaw = [] } = useQuery<LlmConfig[]>({
//     queryKey: ["llm-configs"],
//     queryFn: () => http.get<LlmConfig[]>("/api/v1/llm-configs"),
//     enabled: queryEnabled,
//   });

//   const { data: domainsRaw = [] } = useQuery<DomainSummary[]>({
//     queryKey: ["domains"],
//     queryFn: () => http.get<DomainSummary[]>("/api/v1/domains"),
//     enabled: queryEnabled,
//   });

//   const { data: myCampaignsRaw } = useQuery<unknown>({
//     queryKey: ["campaigns", "my-list"],
//     queryFn: () => http.get<unknown>("/api/v1/campaigns?limit=50"),
//     enabled: queryEnabled,
//     staleTime: 60_000,
//   });

//   const { data: senderIdentitiesRaw = [] } = useQuery<SenderIdentity[]>({
//     queryKey: ["sender-identities"],
//     queryFn: () =>
//       http.get<SenderIdentity[]>("/api/v1/sender-identities").then((r) =>
//         Array.isArray(r) ? r : (r as any)?.items ?? []
//       ),
//     enabled: queryEnabled,
//   });

//   const { data: checklist } = useQuery<ChecklistData>({
//     queryKey: ["onboarding-checklist"],
//     queryFn: () => http.get<ChecklistData>("/api/v1/onboarding/checklist"),
//     enabled: queryEnabled,
//   });

//   const agg = (dashRaw as any)?.aggregation ?? null;
//   // const topCampaigns: Array<{
//   //   id: string;
//   //   name: string;
//   //   status: string;
//   //   replyRate?: number | null;
//   // }> = (dashRaw as any)?.topCampaigns ?? [];

//   const userName: string | undefined = (dashRaw as any)?.user_name ?? undefined;

//   const hasActiveLlm = llmConfigsRaw.some(
//     (c) => (c as any).is_active === true || c.isActive === true
//   );

//   const domainsReady = domainsRaw.filter(
//     (d) => d.spfStatus === true && d.dkimStatus === true && d.dmarcStatus === true
//   ).length;
//   const domainsTotal = domainsRaw.length;

//   const totalProspects: number = agg?.totalProspects ?? 0;
//   const activeCampaigns: number = agg?.activeCampaigns ?? 0;
//   const emailsSentThisWeek: number = agg?.sentThisWeek ?? 0;
//   const avgReplyRate: number = agg?.averageReplyRate ?? 0;

//   const myCampaignsList: Array<{
//     id: string;
//     name: string;
//     status: string;
//     prospect_count?: number;
//   }> = (() => {
//     if (!myCampaignsRaw) return [];
//     const items = Array.isArray(myCampaignsRaw)
//       ? myCampaignsRaw
//       : ((myCampaignsRaw as any).items ?? []);
//     return (items as any[]).map((c) => ({
//       id: c.id,
//       name: c.name,
//       status: c.status,
//       // prospect_count: c.prospect_count ?? c.prospectCount ?? undefined,
//       prospect_count: c._count?.prospects ?? c.prospect_count ?? c.prospectCount ?? undefined,
//     }));
//   })();
//   const activeCampaignCount = myCampaignsList.filter(
//     (c) => c.status?.toLowerCase() === "active"
//   ).length;

//   const defaultIdentity = senderIdentitiesRaw.find((s) => s.isDefault) ?? senderIdentitiesRaw[0];
//   const senderTotal = senderIdentitiesRaw.length;

//   const timeSeriesPoints: Array<{ date: string; sent: number; replied: number }> =
//     (dashRaw as any)?.timeSeries?.points ?? [];
//   const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
//   const chartData = timeSeriesPoints
//     .filter((p) => new Date(p.date) >= sevenDaysAgo)
//     .map((p) => ({
//       date: new Date(p.date).toLocaleDateString("en-US", { weekday: "short" }),
//       Sent: p.sent,
//       Replies: p.replied,
//     }));

//   // All-time emails sent — sourced from backend DashboardAggregation.totalEmailsSent
//   // (count of all Sequence rows where sentAt is set, no date filter).
//   const totalEmailsSent: number = agg?.totalEmailsSent ?? 0;

//   const repliesThisWeek: number = agg?.repliesThisWeek ?? 0;
//   const meetingsThisWeek: number = agg?.meetingsThisWeek ?? 0;
//   const pipelineValue: number = agg?.pipelineValue ?? 0;

//   const quota = (() => {
//     if (!quotaData) return null;
//     const q = quotaData as any;
//     const bindingLimit: number =
//       q.effective_daily_quota ?? q.daily_quota ?? 100;
//     return {
//       ...q,
//       daily_quota: bindingLimit,
//       remaining: q.remaining ?? Math.max(0, bindingLimit - (q.emails_sent ?? 0)),
//     };
//   })();

//   // const quotaSource: string = (quotaData as any)?.quota_source ?? "identity";

//   const quotaPct = quota
//     ? Math.round((quota.emails_sent / Math.max(quota.daily_quota, 1)) * 100)
//     : 0;

//   if (dashLoading) {
//     return (
//       <div className="space-y-6 p-6">
//         <Skeleton className="h-8 w-48" />
//         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
//           {Array.from({ length: 5 }).map((_, i) => (
//             <Skeleton key={i} className="h-24 rounded-xl" />
//           ))}
//         </div>
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           <Skeleton className="h-56 rounded-xl" />
//           <Skeleton className="h-56 rounded-xl" />
//         </div>
//         <Skeleton className="h-40 rounded-xl" />
//       </div>
//     );
//   }

//   if (dashError) {
//     return (
//       <ErrorState
//         title="Dashboard failed to load"
//         description={
//           (dashErr as { message?: string })?.message ??
//           "Could not reach the backend. Check your connection."
//         }
//         onRetry={refetchDash}
//       />
//     );
//   }

//   /* ════════════════════════════════════════════════════════════════════════ */
//   /*  Render                                                                  */
//   /* ════════════════════════════════════════════════════════════════════════ */

//   return (
//     <div className="space-y-6">
//       <PageHeader
//         live
//         title={`Welcome back${userName ? `, ${userName.split(" ")[0]}` : ""}`}
//         description="Your outreach command center"
//       />

//       {/* ── LLM Warning Banner ───────────────────────────────────────────── */}
//       {!hasActiveLlm && (
//         <Card className="border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800">
//           <CardContent className="p-4 flex items-center gap-4">
//             <AlertCircle className="h-5 w-5 text-amber-600 shrink-0" />
//             <div className="flex-1">
//               <p className="font-medium text-sm text-amber-900 dark:text-amber-200">
//                 No LLM configured yet
//               </p>
//               <p className="text-xs text-amber-700 dark:text-amber-400">
//                 Connect an AI model to start generating personalized outreach emails.
//               </p>
//             </div>
//             <Button
//               size="sm"
//               onClick={() => navigate("/setup/llm-models")}
//               className="shrink-0"
//             >
//               <Plus className="h-4 w-4 mr-1" />
//               Configure LLM
//             </Button>
//           </CardContent>
//         </Card>
//       )}

//       {/* ── 5 Stat Cards ─────────────────────────────────────────────────── */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
//         {[
//           {
//             label: "Total Prospects",
//             value: totalProspects.toLocaleString(),
//             icon: <Users className="h-4 w-4" />,
//             colorCls: "text-emerald-600 bg-emerald-50 dark:bg-emerald-950/40",
//           },
//           {
//             label: "Active Campaigns",
//             value: activeCampaigns.toLocaleString(),
//             icon: <PlayCircle className="h-4 w-4" />,
//             colorCls: "text-blue-600 bg-blue-50 dark:bg-blue-950/40",
//           },
//           {
//             label: "Emails Sent",
//             value: totalEmailsSent.toLocaleString(),
//             icon: <Send className="h-4 w-4" />,
//             colorCls: "text-violet-600 bg-violet-50 dark:bg-violet-950/40",
//           },
//           {
//             label: "Avg Reply Rate",
//             value: fmtPct(avgReplyRate),
//             icon: <MessageSquare className="h-4 w-4" />,
//             colorCls: "text-rose-600 bg-rose-50 dark:bg-rose-950/40",
//           },
//           {
//             label: "Domains Ready",
//             value: `${domainsReady}/${domainsTotal}`,
//             icon: <Globe className="h-4 w-4" />,
//             colorCls:
//               domainsReady === domainsTotal && domainsTotal > 0
//                 ? "text-teal-600 bg-teal-50 dark:bg-teal-950/40"
//                 : "text-amber-600 bg-amber-50 dark:bg-amber-950/40",
//           },
//         ].map((s) => (
//           <Card key={s.label}>
//             <CardContent className="p-4">
//               <div className="flex items-center gap-3">
//                 <div className={cn("p-2 rounded-lg", s.colorCls)}>{s.icon}</div>
//                 <div>
//                   <p className="text-2xl font-bold leading-tight">{s.value}</p>
//                   <p className="text-xs text-muted-foreground">{s.label}</p>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         ))}
//       </div>

//       {/* ── 7d activity stat cards + quota ───────────────────────────────── */}
//       {/* Change 1: Added Email Quota Today as 5th card. Big quota card removed below. */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
//         <StatCard
//           label="Emails Sent (7d)"
//           value={emailsSentThisWeek.toLocaleString()}
//           icon={<Send className="h-4 w-4" />}
//         />
//         <StatCard
//           label="Replies (7d)"
//           value={repliesThisWeek.toLocaleString()}
//           icon={<Reply className="h-4 w-4" />}
//         />
//         <StatCard
//           label="Meetings Booked (7d)"
//           value={meetingsThisWeek.toLocaleString()}
//           icon={<CalendarCheck className="h-4 w-4" />}
//         />
//         <StatCard
//           label="Pipeline Value"
//           value={formatCurrency(pipelineValue)}
//           icon={<TrendingUp className="h-4 w-4" />}
//         />
//         {/* Email Quota Today — compact stat card version */}
//         <Card>
//           <CardContent className="p-5">
//             <div className="flex items-center justify-between">
//               <p className="text-sm font-medium text-muted-foreground">Quota Today</p>
//               <Mail className="h-4 w-4 text-muted-foreground" />
//             </div>
//             {quota ? (
//               <>
//                 <p className={cn(
//                   "mt-2 text-2xl font-bold",
//                   quotaPct >= 90
//                     ? "text-red-500"
//                     : quotaPct >= 70
//                     ? "text-amber-500"
//                     : "text-foreground"
//                 )}>
//                   {quota.emails_sent.toLocaleString()}
//                   <span className="text-sm font-normal text-muted-foreground">
//                     {" "}/ {quota.daily_quota.toLocaleString()}
//                   </span>
//                 </p>
//                 <Progress
//                   value={quotaPct}
//                   className={cn(
//                     "mt-2 h-1.5",
//                     quotaPct >= 90
//                       ? "[&>div]:bg-rose-500"
//                       : quotaPct >= 70
//                       ? "[&>div]:bg-amber-500"
//                       : "[&>div]:bg-primary"
//                   )}
//                 />
//                 <p className="mt-1 text-xs text-muted-foreground">
//                   {quota.remaining.toLocaleString()} remaining
//                 </p>
//               </>
//             ) : (
//               <p className="mt-2 text-2xl font-bold text-muted-foreground">—</p>
//             )}
//           </CardContent>
//         </Card>
//       </div>

//       {/* ── My Campaigns + 7-Day Activity (side by side) ─────────────────── */}
//       {/* Change 3: My Campaigns and chart now side by side in a 2-col grid   */}
//       {/* Change 2: My Campaigns table scrollable, max 6 rows visible          */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

//         {/* My Campaigns — left col */}
//         <Card className="flex flex-col">
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base flex items-center justify-between">
//               <span>My Campaigns</span>
//               <Badge variant="secondary">{activeCampaignCount} active</Badge>
//             </CardTitle>
//           </CardHeader>
//           <CardContent className="p-0 flex-1">
//             {!myCampaignsList.length ? (
//               <EmptyState
//                 title="No campaigns yet"
//                 description="Create your first campaign to start sending outreach."
//                 action={
//                   <Button size="sm" onClick={() => navigate("/outreach/campaigns")}>
//                     Create Campaign
//                   </Button>
//                 }
//               />
//             ) : (
//               /* Scrollable wrapper — shows 6 rows (each ~44px) then scrolls */
//               <div className="overflow-y-auto" style={{ maxHeight: "264px" }}>
//                 <Table>
//                   <TableHeader className="sticky top-0 bg-card z-10">
//                     <TableRow>
//                       <TableHead>Name</TableHead>
//                       <TableHead>Status</TableHead>
//                       <TableHead className="text-right">Prospects</TableHead>
//                       <TableHead />
//                     </TableRow>
//                   </TableHeader>
//                   <TableBody>
//                     {myCampaignsList.map((c) => (
//                       <TableRow key={c.id}>
//                         <TableCell className="font-medium">{c.name}</TableCell>
//                         <TableCell>
//                           <Badge variant={statusVariant(c.status)}>
//                             {CAMPAIGN_STATUS_LABEL[c.status] ?? toProperCase(c.status)}
//                           </Badge>
//                         </TableCell>
//                         <TableCell className="text-right">
//                           {c.prospect_count?.toLocaleString() ?? "—"}
//                         </TableCell>
//                         <TableCell className="w-8">
//                           <Button
//                             variant="ghost"
//                             size="icon"
//                             className="h-7 w-7"
//                             onClick={() => navigate(`/outreach/campaigns/${c.id}`)}
//                           >
//                             <ChevronRight className="h-4 w-4" />
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </div>
//             )}
//           </CardContent>
//         </Card>

//         {/* 7-Day Activity chart — right col */}
//         <Card>
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base">7-Day Activity</CardTitle>
//             <CardDescription>Emails sent vs replies</CardDescription>
//           </CardHeader>
//           <CardContent>
//             {chartData.length === 0 ? (
//               <div className="h-48 flex items-center justify-center text-sm text-muted-foreground">
//                 No activity data yet
//               </div>
//             ) : (
//               <ResponsiveContainer width="100%" height={200}>
//                 <BarChart data={chartData} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
//                   <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
//                   <XAxis
//                     dataKey="date"
//                     tick={{ fontSize: 11 }}
//                     tickLine={false}
//                     axisLine={false}
//                   />
//                   <YAxis tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
//                   <Tooltip />
//                   <Bar dataKey="Sent" fill="#6366f1" radius={[3, 3, 0, 0]} />
//                   <Bar dataKey="Replies" fill="#10b981" radius={[3, 3, 0, 0]} />
//                 </BarChart>
//               </ResponsiveContainer>
//             )}
//           </CardContent>
//         </Card>

//       </div>

//       {/* ── Onboarding checklist ─────────────────────────────────────────── */}
//       {checklist && !checklist.all_done && (
//         <Card>
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base flex items-center justify-between">
//               <span>Getting Started</span>
//               <span className="text-sm font-normal text-muted-foreground">
//                 {checklist.completed}/{checklist.total} complete
//               </span>
//             </CardTitle>
//             <Progress
//               value={Math.round((checklist.completed / checklist.total) * 100)}
//               className="h-1.5 mt-1"
//             />
//           </CardHeader>
//           <CardContent>
//             <div className="space-y-2">
//               {checklist.items
//                 .sort((a, b) => a.order - b.order)
//                 .map((item) => (
//                   <div
//                     key={item.key}
//                     className={cn(
//                       "flex items-start gap-3 p-2.5 rounded-lg transition-colors",
//                       item.done ? "opacity-50" : "hover:bg-accent cursor-pointer"
//                     )}
//                     onClick={() => !item.done && navigate(item.link)}
//                   >
//                     <div
//                       className={cn(
//                         "mt-0.5 h-4 w-4 rounded-full border-2 shrink-0 flex items-center justify-center",
//                         item.done
//                           ? "border-primary bg-primary"
//                           : "border-muted-foreground"
//                       )}
//                     >
//                       {item.done && (
//                         <svg
//                           className="h-2.5 w-2.5 text-primary-foreground"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M2 5l2.5 2.5L8 3"
//                             stroke="currentColor"
//                             strokeWidth="1.5"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       )}
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium">{item.label}</p>
//                       <p className="text-xs text-muted-foreground">{item.description}</p>
//                     </div>
//                   </div>
//                 ))}
//             </div>
//           </CardContent>
//         </Card>
//       )}

//       {/* My Campaigns moved above — see Change 4 */}

//       {/* ── Sender identities ────────────────────────────────────────────── */}
//       {senderTotal > 0 && (
//         <Card>
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base flex items-center gap-2">
//               <Users2 className="h-4 w-4" />
//               Sender Identity
//             </CardTitle>
//           </CardHeader>
//           <CardContent>
//             <p className="text-sm">
//               <span className="text-muted-foreground">Default: </span>
//               <span className="font-medium font-mono text-sm">
//                 {defaultIdentity?.email ?? "—"}
//               </span>
//             </p>
//             <p className="text-xs text-muted-foreground mt-1">
//               {senderTotal} identit{senderTotal === 1 ? "y" : "ies"} configured
//             </p>
//             <Button
//               variant="outline"
//               size="sm"
//               className="mt-3"
//               onClick={() => navigate("/setup/sender-identities")}
//             >
//               Manage Identities
//             </Button>
//           </CardContent>
//         </Card>
//       )}

//       {/* ── Quick Actions (full-width) ───────────────────────────────────── */}
//       {/* Change 3: Moved here from the 2-col grid; now full-width like Workflow Guide */}
//       <Card>
//         <CardHeader className="pb-3">
//           <CardTitle className="text-base">Quick Actions</CardTitle>
//           <CardDescription>Jump to any part of the platform</CardDescription>
//         </CardHeader>
//         <CardContent>
//           <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-9 gap-2">
//             {QUICK_ACTIONS.map((action) => {
//               const Icon = action.icon;
//               return (
//                 <button
//                   key={action.label}
//                   onClick={() => navigate(action.path)}
//                   className="flex flex-col items-center gap-1.5 p-2.5 rounded-lg border border-border hover:bg-accent transition-colors text-center"
//                 >
//                   <Icon className="h-4 w-4 text-muted-foreground" />
//                   <span className="text-xs leading-tight">{action.label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </CardContent>
//       </Card>

//       {/* ── 10-Step AI Outreach Workflow Guide ───────────────────────────── */}
//       <Card>
//         <CardHeader className="pb-3">
//           <CardTitle className="text-base">AI Outreach Workflow</CardTitle>
//           <CardDescription>
//             Follow these 10 steps from setup to closed-won deals
//           </CardDescription>
//         </CardHeader>
//         <CardContent>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
//             {WORKFLOW_STEPS.map((s) => (
//               <button
//                 key={s.step}
//                 onClick={() => navigate(s.path)}
//                 className="flex items-start gap-3 p-3 rounded-lg border border-border hover:bg-accent transition-colors text-left"
//               >
//                 <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-bold">
//                   {s.step}
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium">{s.title}</p>
//                   <p className="text-xs text-muted-foreground">{s.desc}</p>
//                 </div>
//               </button>
//             ))}
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }

// import { useQuery } from "@tanstack/react-query";
// import {
//   Bar,
//   BarChart,
//   CartesianGrid,
//   ResponsiveContainer,
//   Tooltip,
//   XAxis,
//   YAxis,
// } from "recharts";
// import {
//   AlertCircle,
//   BarChart3,
//   Bot,
//   BookOpen,
//   CalendarCheck,
//   CalendarDays,
//   ChevronRight,
//   FileText,
//   Globe,
//   Inbox,
//   Kanban,
//   Layers,
//   Lightbulb,
//   Link2,
//   Linkedin,
//   Mail,
//   Megaphone,
//   MessageSquare,
//   PlayCircle,
//   Plus,
//   Reply,
//   Rocket,
//   Send,
  
//   Sparkles,
//   Target,
//   TrendingUp,
//   Users,
//   Users2,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "@/context/AuthContext";
// import {
//   http,
//   managerDashboardApi,
//   senderIdentityApi,
// } from "@/services/apiClient";
// import { ErrorState } from "@/components/ui/error-state";
// import { PageHeader } from "@/components/ui/page-header";
// import { StatCard } from "@/components/ui/stat-card";
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from "@/components/ui/card";
// import { Skeleton } from "@/components/ui/skeleton";
// import { Badge } from "@/components/ui/badge";
// import { Progress } from "@/components/ui/progress";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "@/components/ui/table";
// import { Button } from "@/components/ui/button";
// import { EmptyState } from "@/components/ui/empty-state";
// import { cn, formatCurrency, toProperCase } from "@/lib/utils";

// /* ── Local types ─────────────────────────────────────────────────────────── */

// interface ChecklistItem {
//   key: string;
//   label: string;
//   description: string;
//   link: string;
//   order: number;
//   done: boolean;
// }

// interface ChecklistData {
//   items: ChecklistItem[];
//   completed: number;
//   total: number;
//   all_done: boolean;
// }

// interface LlmConfig {
//   id: string;
//   name: string;
//   isActive: boolean;
//   isDefault: boolean;
// }

// interface SenderIdentity {
//   id: string;
//   email: string;
//   isDefault?: boolean;
// }

// /* ── Quick Actions definition ────────────────────────────────────────────── */

// const QUICK_ACTIONS = [
//   { label: "Add LLM Model",     path: "/setup/llm-models",            icon: Bot },
//   { label: "Manage Prompts",    path: "/setup/prompts",               icon: FileText },
//   { label: "Create ICP",        path: "/prospecting/icp-profiles",    icon: Target },
//   { label: "Add Prospect",      path: "/prospects",                   icon: Users },
//   { label: "Integrations",      path: "/setup/integrations",          icon: Link2 },
//   { label: "Run Autopilot",     path: "/prospecting/autopilot",       icon: Rocket },
//   { label: "Campaigns",         path: "/outreach/campaigns",          icon: Megaphone },
//   { label: "Generate Email",    path: "/outreach/email-studio",       icon: Sparkles },
//   { label: "Build Sequence",    path: "/outreach/sequences",          icon: Layers },
//   { label: "Setup Domain",      path: "/setup/domains",               icon: Globe },
//   { label: "Analytics",         path: "/optimize/analytics",          icon: BarChart3 },
//   { label: "Templates",         path: "/outreach/templates",          icon: BookOpen },
//   { label: "Track Deals",       path: "/pipeline/deals",              icon: Kanban },
//   { label: "Reply Inbox",       path: "/outreach/reply-inbox",        icon: Inbox },
//   { label: "LinkedIn Hub",      path: "/prospecting/linkedin",        icon: Linkedin },
//   { label: "Content Ideas",     path: "/optimize/content-ideas",      icon: Lightbulb },
//   { label: "Weekly Digest",     path: "/optimize/weekly-digest",      icon: CalendarDays },
// ] as const;

// /* ── Workflow steps definition ───────────────────────────────────────────── */

// const WORKFLOW_STEPS = [
//   { step: 1,  title: "Connect AI Model",       desc: "Set up your LLM provider",         path: "/setup/llm-models" },
//   { step: 2,  title: "Setup Domain",           desc: "Configure sending domain & DNS",   path: "/setup/domains" },
//   { step: 3,  title: "Configure Integrations", desc: "Connect MailBridge & data tools",  path: "/setup/integrations" },
//   { step: 4,  title: "Define ICP",             desc: "Create ideal customer profile",    path: "/prospecting/icp-profiles" },
//   { step: 5,  title: "Import Prospects",       desc: "Add & enrich your leads",          path: "/prospects" },
//   { step: 6,  title: "Run Autopilot",          desc: "AI GTM pipeline — 60 seconds",     path: "/prospecting/autopilot" },
//   { step: 7,  title: "Generate Emails",        desc: "AI copywriting & QA scoring",      path: "/outreach/email-studio" },
//   { step: 8,  title: "Build Sequence",         desc: "Multi-touch cadence",              path: "/outreach/sequences" },
//   { step: 9,  title: "Track Replies",          desc: "Manage inbox & AI drafts",         path: "/outreach/reply-inbox" },
//   { step: 10, title: "Close Deals",            desc: "Pipeline & revenue tracking",      path: "/pipeline/deals" },
// ] as const;

// /* ── Helpers ─────────────────────────────────────────────────────────────── */

// /**
//  * CASING FIX: explicit display labels for campaign status enum values.
//  * The backend returns lowercase strings (active, draft, paused, etc.).
//  */
// const CAMPAIGN_STATUS_LABEL: Record<string, string> = {
//   active: "Active",
//   draft: "Draft",
//   paused: "Paused",
//   completed: "Completed",
//   archived: "Archived",
// };

// function statusVariant(status: string): "default" | "secondary" | "destructive" | "outline" {
//   const s = status.toLowerCase();
//   if (s === "active") return "default";
//   if (s === "paused") return "secondary";
//   if (s === "draft") return "outline";
//   return "secondary";
// }

// function fmtPct(rate: number): string {
//   return `${(rate * 100).toFixed(1)}%`;
// }

// /* ══════════════════════════════════════════════════════════════════════════ */
// /*  Component                                                                */
// /* ══════════════════════════════════════════════════════════════════════════ */

// export function UserDashboardPage() {
//   const { initialized, isAuthenticated } = useAuth();
//   const navigate = useNavigate();

//   const queryEnabled = initialized && isAuthenticated;

//   const {
//     data: dashRaw,
//     isLoading: dashLoading,
//     isError: dashError,
//     error: dashErr,
//     refetch: refetchDash,
//   } = useQuery({
//     queryKey: ["dashboard", "me"],
//     queryFn: () => managerDashboardApi.mine(),
//     enabled: queryEnabled,
//     retry: (failureCount, err) => {
//       const status = (err as { response?: { status?: number } })?.response?.status;
//       if (status === 401 || status === 403) return false;
//       return failureCount < 1;
//     },
//   });

//   const { data: quotaData } = useQuery({
//     queryKey: ["email-quota", "me"],
//     queryFn: () => senderIdentityApi.myQuota(),
//     enabled: queryEnabled,
//   });

//   const { data: llmConfigsRaw = [] } = useQuery<LlmConfig[]>({
//     queryKey: ["llm-configs"],
//     queryFn: () => http.get<LlmConfig[]>("/api/v1/llm-configs"),
//     enabled: queryEnabled,
//   });

//   const { data: myCampaignsRaw } = useQuery<unknown>({
//     queryKey: ["campaigns", "my-list"],
//     queryFn: () => http.get<unknown>("/api/v1/campaigns?limit=50"),
//     enabled: queryEnabled,
//     staleTime: 60_000,
//   });

//   const { data: senderIdentitiesRaw = [] } = useQuery<SenderIdentity[]>({
//     queryKey: ["sender-identities"],
//     queryFn: () =>
//       http.get<SenderIdentity[]>("/api/v1/sender-identities").then((r) =>
//         Array.isArray(r) ? r : (r as any)?.items ?? []
//       ),
//     enabled: queryEnabled,
//   });

//   const { data: checklist } = useQuery<ChecklistData>({
//     queryKey: ["onboarding-checklist"],
//     queryFn: () => http.get<ChecklistData>("/api/v1/onboarding/checklist"),
//     enabled: queryEnabled,
//   });

//   const agg = (dashRaw as any)?.aggregation ?? null;
//   // const topCampaigns: Array<{
//   //   id: string;
//   //   name: string;
//   //   status: string;
//   //   replyRate?: number | null;
//   // }> = (dashRaw as any)?.topCampaigns ?? [];

//   const userName: string | undefined = (dashRaw as any)?.user_name ?? undefined;

//   const hasActiveLlm = llmConfigsRaw.some(
//     (c) => (c as any).is_active === true || c.isActive === true
//   );

//   const totalProspects: number = agg?.totalProspects ?? 0;
//   const activeCampaigns: number = agg?.activeCampaigns ?? 0;
//   // const emailsSentThisWeek: number = agg?.sentThisWeek ?? 0;
//   const avgReplyRate: number = agg?.averageReplyRate ?? 0;

//   const myCampaignsList: Array<{
//     id: string;
//     name: string;
//     status: string;
//     prospect_count?: number;
//   }> = (() => {
//     if (!myCampaignsRaw) return [];
//     const items = Array.isArray(myCampaignsRaw)
//       ? myCampaignsRaw
//       : ((myCampaignsRaw as any).items ?? []);
//     return (items as any[]).map((c) => ({
//       id: c.id,
//       name: c.name,
//       status: c.status,
//       // prospect_count: c.prospect_count ?? c.prospectCount ?? undefined,
//       prospect_count: c._count?.prospects ?? c.prospect_count ?? c.prospectCount ?? undefined,
//     }));
//   })();
//   const activeCampaignCount = myCampaignsList.filter(
//     (c) => c.status?.toLowerCase() === "active"
//   ).length;

//   const defaultIdentity = senderIdentitiesRaw.find((s) => s.isDefault) ?? senderIdentitiesRaw[0];
//   const senderTotal = senderIdentitiesRaw.length;

//   const timeSeriesPoints: Array<{ date: string; sent: number; replied: number }> =
//     (dashRaw as any)?.timeSeries?.points ?? [];
//   const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
//   const chartData = timeSeriesPoints
//     .filter((p) => new Date(p.date) >= sevenDaysAgo)
//     .map((p) => ({
//       date: new Date(p.date).toLocaleDateString("en-US", { weekday: "short" }),
//       Sent: p.sent,
//       Replies: p.replied,
//     }));

//   // All-time emails sent — sourced from backend DashboardAggregation.totalEmailsSent
//   // (count of all Sequence rows where sentAt is set, no date filter).
//   const totalEmailsSent: number = agg?.totalEmailsSent ?? 0;

//   const repliesThisWeek: number = agg?.repliesThisWeek ?? 0;
//   const meetingsThisWeek: number = agg?.meetingsThisWeek ?? 0;
//   const pipelineValue: number = agg?.pipelineValue ?? 0;

//   const quota = (() => {
//     if (!quotaData) return null;
//     const q = quotaData as any;
//     const bindingLimit: number =
//       q.effective_daily_quota ?? q.daily_quota ?? 100;
//     return {
//       ...q,
//       daily_quota: bindingLimit,
//       remaining: q.remaining ?? Math.max(0, bindingLimit - (q.emails_sent ?? 0)),
//     };
//   })();

//   // const quotaSource: string = (quotaData as any)?.quota_source ?? "identity";

//   const quotaPct = quota
//     ? Math.round((quota.emails_sent / Math.max(quota.daily_quota, 1)) * 100)
//     : 0;

//   if (dashLoading) {
//     return (
//       <div className="space-y-6 p-6">
//         <Skeleton className="h-8 w-48" />
//         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
//           {Array.from({ length: 5 }).map((_, i) => (
//             <Skeleton key={i} className="h-24 rounded-xl" />
//           ))}
//         </div>
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           <Skeleton className="h-56 rounded-xl" />
//           <Skeleton className="h-56 rounded-xl" />
//         </div>
//         <Skeleton className="h-40 rounded-xl" />
//       </div>
//     );
//   }

//   if (dashError) {
//     return (
//       <ErrorState
//         title="Dashboard failed to load"
//         description={
//           (dashErr as { message?: string })?.message ??
//           "Could not reach the backend. Check your connection."
//         }
//         onRetry={refetchDash}
//       />
//     );
//   }

//   /* ════════════════════════════════════════════════════════════════════════ */
//   /*  Render                                                                  */
//   /* ════════════════════════════════════════════════════════════════════════ */

//   return (
//     <div className="space-y-6">
//       <PageHeader
//         live
//         title={`Welcome back${userName ? `, ${userName.split(" ")[0]}` : ""}`}
//         description="Your outreach command center"
//       />

//       {/* ── LLM Warning Banner ───────────────────────────────────────────── */}
//       {!hasActiveLlm && (
//         <Card className="border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800">
//           <CardContent className="p-4 flex items-center gap-4">
//             <AlertCircle className="h-5 w-5 text-amber-600 shrink-0" />
//             <div className="flex-1">
//               <p className="font-medium text-sm text-amber-900 dark:text-amber-200">
//                 No LLM configured yet
//               </p>
//               <p className="text-xs text-amber-700 dark:text-amber-400">
//                 Connect an AI model to start generating personalized outreach emails.
//               </p>
//             </div>
//             <Button
//               size="sm"
//               onClick={() => navigate("/setup/llm-models")}
//               className="shrink-0"
//             >
//               <Plus className="h-4 w-4 mr-1" />
//               Configure LLM
//             </Button>
//           </CardContent>
//         </Card>
//       )}

//       {/* ── 5 Stat Cards ─────────────────────────────────────────────────── */}
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
//         {[
//           {
//             label: "Total Prospects",
//             value: totalProspects.toLocaleString(),
//             icon: <Users className="h-4 w-4" />,
//             colorCls: "text-emerald-600 bg-emerald-50 dark:bg-emerald-950/40",
//           },
//           {
//             label: "Active Campaigns",
//             value: activeCampaigns.toLocaleString(),
//             icon: <PlayCircle className="h-4 w-4" />,
//             colorCls: "text-blue-600 bg-blue-50 dark:bg-blue-950/40",
//           },
//           {
//             label: "Emails Sent",
//             value: totalEmailsSent.toLocaleString(),
//             icon: <Send className="h-4 w-4" />,
//             colorCls: "text-violet-600 bg-violet-50 dark:bg-violet-950/40",
//           },
//           {
//             label: "Avg Reply Rate",
//             value: fmtPct(avgReplyRate),
//             icon: <MessageSquare className="h-4 w-4" />,
//             colorCls: "text-rose-600 bg-rose-50 dark:bg-rose-950/40",
//           },
//         ].map((s) => (
//           <Card key={s.label}>
//             <CardContent className="p-4">
//               <div className="flex items-center gap-3">
//                 <div className={cn("p-2 rounded-lg", s.colorCls)}>{s.icon}</div>
//                 <div>
//                   <p className="text-2xl font-bold leading-tight">{s.value}</p>
//                   <p className="text-xs text-muted-foreground">{s.label}</p>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         ))}
//       </div>

//       {/* ── 7d activity stat cards + quota ───────────────────────────────── */}
//       {/* Change 1: Added Email Quota Today as 5th card. Big quota card removed below. */}
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
//         <StatCard
//           label="Replies (7d)"
//           value={repliesThisWeek.toLocaleString()}
//           icon={<Reply className="h-4 w-4" />}
//         />
//         <StatCard
//           label="Meetings Booked (7d)"
//           value={meetingsThisWeek.toLocaleString()}
//           icon={<CalendarCheck className="h-4 w-4" />}
//         />
//         <StatCard
//           label="Pipeline Value"
//           value={formatCurrency(pipelineValue)}
//           icon={<TrendingUp className="h-4 w-4" />}
//         />
//         {/* Email Quota Today — compact stat card version */}
//         <Card>
//           <CardContent className="p-5">
//             <div className="flex items-center justify-between">
//               <p className="text-sm font-medium text-muted-foreground">Quota Today</p>
//               <Mail className="h-4 w-4 text-muted-foreground" />
//             </div>
//             {quota ? (
//               <>
//                 <p className={cn(
//                   "mt-2 text-2xl font-bold",
//                   quotaPct >= 90
//                     ? "text-red-500"
//                     : quotaPct >= 70
//                     ? "text-amber-500"
//                     : "text-foreground"
//                 )}>
//                   {quota.emails_sent.toLocaleString()}
//                   <span className="text-sm font-normal text-muted-foreground">
//                     {" "}/ {quota.daily_quota.toLocaleString()}
//                   </span>
//                 </p>
//                 <Progress
//                   value={quotaPct}
//                   className={cn(
//                     "mt-2 h-1.5",
//                     quotaPct >= 90
//                       ? "[&>div]:bg-rose-500"
//                       : quotaPct >= 70
//                       ? "[&>div]:bg-amber-500"
//                       : "[&>div]:bg-primary"
//                   )}
//                 />
//                 <p className="mt-1 text-xs text-muted-foreground">
//                   {quota.remaining.toLocaleString()} remaining
//                 </p>
//               </>
//             ) : (
//               <p className="mt-2 text-2xl font-bold text-muted-foreground">—</p>
//             )}
//           </CardContent>
//         </Card>
//       </div>

//       {/* ── My Campaigns + 7-Day Activity (side by side) ─────────────────── */}
//       {/* Change 3: My Campaigns and chart now side by side in a 2-col grid   */}
//       {/* Change 2: My Campaigns table scrollable, max 6 rows visible          */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

//         {/* My Campaigns — left col */}
//         <Card className="flex flex-col">
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base flex items-center justify-between">
//               <span>My Campaigns</span>
//               <Badge variant="secondary">{activeCampaignCount} active</Badge>
//             </CardTitle>
//           </CardHeader>
//           <CardContent className="p-0 flex-1">
//             {!myCampaignsList.length ? (
//               <EmptyState
//                 title="No campaigns yet"
//                 description="Create your first campaign to start sending outreach."
//                 action={
//                   <Button size="sm" onClick={() => navigate("/outreach/campaigns")}>
//                     Create Campaign
//                   </Button>
//                 }
//               />
//             ) : (
//               /* Scrollable wrapper — shows 6 rows (each ~44px) then scrolls */
//               <div className="overflow-y-auto" style={{ maxHeight: "264px" }}>
//                 <Table>
//                   <TableHeader className="sticky top-0 bg-card z-10">
//                     <TableRow>
//                       <TableHead>Name</TableHead>
//                       <TableHead>Status</TableHead>
//                       <TableHead className="text-right">Prospects</TableHead>
//                       <TableHead />
//                     </TableRow>
//                   </TableHeader>
//                   <TableBody>
//                     {myCampaignsList.map((c) => (
//                       <TableRow key={c.id}>
//                         <TableCell className="font-medium">{c.name}</TableCell>
//                         <TableCell>
//                           <Badge variant={statusVariant(c.status)}>
//                             {CAMPAIGN_STATUS_LABEL[c.status] ?? toProperCase(c.status)}
//                           </Badge>
//                         </TableCell>
//                         <TableCell className="text-right">
//                           {c.prospect_count?.toLocaleString() ?? "—"}
//                         </TableCell>
//                         <TableCell className="w-8">
//                           <Button
//                             variant="ghost"
//                             size="icon"
//                             className="h-7 w-7"
//                             onClick={() => navigate(`/outreach/campaigns/${c.id}`)}
//                           >
//                             <ChevronRight className="h-4 w-4" />
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </div>
//             )}
//           </CardContent>
//         </Card>

//         {/* 7-Day Activity chart — right col */}
//         <Card>
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base">7-Day Activity</CardTitle>
//             <CardDescription>Emails sent vs replies</CardDescription>
//           </CardHeader>
//           <CardContent>
//             {chartData.length === 0 ? (
//               <div className="h-48 flex items-center justify-center text-sm text-muted-foreground">
//                 No activity data yet
//               </div>
//             ) : (
//               <ResponsiveContainer width="100%" height={200}>
//                 <BarChart data={chartData} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
//                   <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
//                   <XAxis
//                     dataKey="date"
//                     tick={{ fontSize: 11 }}
//                     tickLine={false}
//                     axisLine={false}
//                   />
//                   <YAxis tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
//                   <Tooltip />
//                   <Bar dataKey="Sent" fill="#6366f1" radius={[3, 3, 0, 0]} />
//                   <Bar dataKey="Replies" fill="#10b981" radius={[3, 3, 0, 0]} />
//                 </BarChart>
//               </ResponsiveContainer>
//             )}
//           </CardContent>
//         </Card>

//       </div>

//       {/* ── Onboarding checklist ─────────────────────────────────────────── */}
//       {checklist && !checklist.all_done && (
//         <Card>
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base flex items-center justify-between">
//               <span>Getting Started</span>
//               <span className="text-sm font-normal text-muted-foreground">
//                 {checklist.completed}/{checklist.total} complete
//               </span>
//             </CardTitle>
//             <Progress
//               value={Math.round((checklist.completed / checklist.total) * 100)}
//               className="h-1.5 mt-1"
//             />
//           </CardHeader>
//           <CardContent>
//             <div className="space-y-2">
//               {checklist.items
//                 .sort((a, b) => a.order - b.order)
//                 .map((item) => (
//                   <div
//                     key={item.key}
//                     className={cn(
//                       "flex items-start gap-3 p-2.5 rounded-lg transition-colors",
//                       item.done ? "opacity-50" : "hover:bg-accent cursor-pointer"
//                     )}
//                     onClick={() => !item.done && navigate(item.link)}
//                   >
//                     <div
//                       className={cn(
//                         "mt-0.5 h-4 w-4 rounded-full border-2 shrink-0 flex items-center justify-center",
//                         item.done
//                           ? "border-primary bg-primary"
//                           : "border-muted-foreground"
//                       )}
//                     >
//                       {item.done && (
//                         <svg
//                           className="h-2.5 w-2.5 text-primary-foreground"
//                           viewBox="0 0 10 10"
//                           fill="none"
//                         >
//                           <path
//                             d="M2 5l2.5 2.5L8 3"
//                             stroke="currentColor"
//                             strokeWidth="1.5"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       )}
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium">{item.label}</p>
//                       <p className="text-xs text-muted-foreground">{item.description}</p>
//                     </div>
//                   </div>
//                 ))}
//             </div>
//           </CardContent>
//         </Card>
//       )}

//       {/* My Campaigns moved above — see Change 4 */}

//       {/* ── Sender identities ────────────────────────────────────────────── */}
//       {senderTotal > 0 && (
//         <Card>
//           <CardHeader className="pb-3">
//             <CardTitle className="text-base flex items-center gap-2">
//               <Users2 className="h-4 w-4" />
//               Sender Identity
//             </CardTitle>
//           </CardHeader>
//           <CardContent>
//             <p className="text-sm">
//               <span className="text-muted-foreground">Default: </span>
//               <span className="font-medium font-mono text-sm">
//                 {defaultIdentity?.email ?? "—"}
//               </span>
//             </p>
//             <p className="text-xs text-muted-foreground mt-1">
//               {senderTotal} identit{senderTotal === 1 ? "y" : "ies"} configured
//             </p>
//             <Button
//               variant="outline"
//               size="sm"
//               className="mt-3"
//               onClick={() => navigate("/setup/sender-identities")}
//             >
//               Manage Identities
//             </Button>
//           </CardContent>
//         </Card>
//       )}

//       {/* ── Quick Actions (full-width) ───────────────────────────────────── */}
//       {/* Change 3: Moved here from the 2-col grid; now full-width like Workflow Guide */}
//       <Card>
//         <CardHeader className="pb-3">
//           <CardTitle className="text-base">Quick Actions</CardTitle>
//           <CardDescription>Jump to any part of the platform</CardDescription>
//         </CardHeader>
//         <CardContent>
//           <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-9 gap-2">
//             {QUICK_ACTIONS.map((action) => {
//               const Icon = action.icon;
//               return (
//                 <button
//                   key={action.label}
//                   onClick={() => navigate(action.path)}
//                   className="flex flex-col items-center gap-1.5 p-2.5 rounded-lg border border-border hover:bg-accent transition-colors text-center"
//                 >
//                   <Icon className="h-4 w-4 text-muted-foreground" />
//                   <span className="text-xs leading-tight">{action.label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </CardContent>
//       </Card>

//       {/* ── 10-Step AI Outreach Workflow Guide ───────────────────────────── */}
//       <Card>
//         <CardHeader className="pb-3">
//           <CardTitle className="text-base">AI Outreach Workflow</CardTitle>
//           <CardDescription>
//             Follow these 10 steps from setup to closed-won deals
//           </CardDescription>
//         </CardHeader>
//         <CardContent>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
//             {WORKFLOW_STEPS.map((s) => (
//               <button
//                 key={s.step}
//                 onClick={() => navigate(s.path)}
//                 className="flex items-start gap-3 p-3 rounded-lg border border-border hover:bg-accent transition-colors text-left"
//               >
//                 <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-bold">
//                   {s.step}
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium">{s.title}</p>
//                   <p className="text-xs text-muted-foreground">{s.desc}</p>
//                 </div>
//               </button>
//             ))}
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// }

import { useQuery } from "@tanstack/react-query";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  AlertCircle,
  BarChart3,
  Bot,
  BookOpen,
  // CalendarCheck,
  // CalendarDays,
  ChevronRight,
  FileText,
  Globe,
  Inbox,
  // Kanban,
  Layers,
  // Lightbulb,
  Link2,
  // Linkedin,
  Mail,
  Megaphone,
  MessageSquare,
  PlayCircle,
  Plus,
  Reply,
  // Rocket,
  Send,
  
  Sparkles,
  Target,
  // TrendingUp,
  Users,
  // Users2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  http,
  managerDashboardApi,
  senderIdentityApi,
} from "@/services/apiClient";
import { ErrorState } from "@/components/ui/error-state";
import { PageHeader } from "@/components/ui/page-header";
import { StatCard } from "@/components/ui/stat-card";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import { cn, toProperCase } from "@/lib/utils";

/* ── Local types ─────────────────────────────────────────────────────────── */

interface ChecklistItem {
  key: string;
  label: string;
  description: string;
  link: string;
  order: number;
  done: boolean;
}

interface ChecklistData {
  items: ChecklistItem[];
  completed: number;
  total: number;
  all_done: boolean;
}

interface LlmConfig {
  id: string;
  name: string;
  isActive: boolean;
  isDefault: boolean;
}

// interface SenderIdentity {
//   id: string;
//   email: string;
//   isDefault?: boolean;
// }

/* ── Quick Actions definition ────────────────────────────────────────────── */
/* HIDDEN quick actions (pages currently disabled):
   - "Run Autopilot"   → /prospecting/autopilot   (Autopilot Pipeline hidden)
   - "LinkedIn Hub"     → /prospecting/linkedin     (LinkedIn Hub hidden)
   - "Track Deals"      → /pipeline/deals           (Pipeline & Deals hidden)
   - "Content Ideas"    → /optimize/content-ideas   (Content Ideas hidden)
   - "Weekly Digest"    → /optimize/weekly-digest    (Weekly Digest hidden)
*/

const QUICK_ACTIONS = [
  { label: "Add LLM Model",     path: "/setup/llm-models",            icon: Bot },
  { label: "Manage Prompts",    path: "/setup/prompts",               icon: FileText },
  { label: "Create ICP",        path: "/prospecting/icp-profiles",    icon: Target },
  { label: "Add Prospect",      path: "/prospects",                   icon: Users },
  { label: "Integrations",      path: "/setup/integrations",          icon: Link2 },
  // { label: "Run Autopilot",     path: "/prospecting/autopilot",       icon: Rocket },       // HIDDEN — Autopilot Pipeline
  { label: "Campaigns",         path: "/outreach/campaigns",          icon: Megaphone },
  { label: "Generate Email",    path: "/outreach/email-studio",       icon: Sparkles },
  { label: "Build Sequence",    path: "/outreach/sequences",          icon: Layers },
  { label: "Setup Domain",      path: "/setup/domains",               icon: Globe },
  { label: "Analytics",         path: "/optimize/analytics",          icon: BarChart3 },
  { label: "Templates",         path: "/outreach/templates",          icon: BookOpen },
  // { label: "Track Deals",       path: "/pipeline/deals",              icon: Kanban },        // HIDDEN — Pipeline & Deals
  { label: "Reply Inbox",       path: "/outreach/reply-inbox",        icon: Inbox },
  // { label: "LinkedIn Hub",      path: "/prospecting/linkedin",        icon: Linkedin },      // HIDDEN — LinkedIn Hub
  // { label: "Content Ideas",     path: "/optimize/content-ideas",      icon: Lightbulb },     // HIDDEN — Content Ideas
  // { label: "Weekly Digest",     path: "/optimize/weekly-digest",      icon: CalendarDays },  // HIDDEN — Weekly Digest
] as const;

/* ── Workflow steps definition ───────────────────────────────────────────── */
/* HIDDEN workflow steps:
   - Step 6 "Run Autopilot" (Autopilot Pipeline hidden)
   - Step 10 "Close Deals"  (Pipeline & Deals hidden)
   Remaining 8 steps re-numbered 1–8, displayed as top 4 + bottom 4.
*/

const WORKFLOW_STEPS = [
  { step: 1,  title: "Connect AI Model",       desc: "Set up your LLM provider",         path: "/setup/llm-models" },
  { step: 2,  title: "Setup Domain",           desc: "Configure sending domain & DNS",   path: "/setup/domains" },
  { step: 3,  title: "Configure Integrations", desc: "Connect MailBridge & data tools",  path: "/setup/integrations" },
  { step: 4,  title: "Define ICP",             desc: "Create ideal customer profile",    path: "/prospecting/icp-profiles" },
  { step: 5,  title: "Import Prospects",       desc: "Add & enrich your leads",          path: "/prospects" },
  // { step: 6,  title: "Run Autopilot",          desc: "AI GTM pipeline — 60 seconds",     path: "/prospecting/autopilot" },  // HIDDEN
  { step: 6,  title: "Generate Emails",        desc: "AI copywriting & QA scoring",      path: "/outreach/email-studio" },
  { step: 7,  title: "Build Sequence",         desc: "Multi-touch cadence",              path: "/outreach/sequences" },
  { step: 8,  title: "Track Replies",          desc: "Manage inbox & AI drafts",         path: "/outreach/reply-inbox" },
  // { step: 10, title: "Close Deals",            desc: "Pipeline & revenue tracking",      path: "/pipeline/deals" },          // HIDDEN
] as const;

/* ── Helpers ─────────────────────────────────────────────────────────────── */

/**
 * CASING FIX: explicit display labels for campaign status enum values.
 * The backend returns lowercase strings (active, draft, paused, etc.).
 */
const CAMPAIGN_STATUS_LABEL: Record<string, string> = {
  active: "Active",
  draft: "Draft",
  paused: "Paused",
  completed: "Completed",
  archived: "Archived",
};

function statusVariant(status: string): "default" | "secondary" | "destructive" | "outline" {
  const s = status.toLowerCase();
  if (s === "active") return "default";
  if (s === "paused") return "secondary";
  if (s === "draft") return "outline";
  return "secondary";
}

function fmtPct(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}

/* ══════════════════════════════════════════════════════════════════════════ */
/*  Component                                                                */
/* ══════════════════════════════════════════════════════════════════════════ */

export function UserDashboardPage() {
  const { initialized, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const queryEnabled = initialized && isAuthenticated;

  const {
    data: dashRaw,
    isLoading: dashLoading,
    isError: dashError,
    error: dashErr,
    refetch: refetchDash,
  } = useQuery({
    queryKey: ["dashboard", "me"],
    queryFn: () => managerDashboardApi.mine(),
    enabled: queryEnabled,
    retry: (failureCount, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      if (status === 401 || status === 403) return false;
      return failureCount < 1;
    },
  });

  const { data: quotaData } = useQuery({
    queryKey: ["email-quota", "me"],
    queryFn: () => senderIdentityApi.myQuota(),
    enabled: queryEnabled,
  });

  const { data: llmConfigsRaw = [] } = useQuery<LlmConfig[]>({
    queryKey: ["llm-configs"],
    queryFn: () => http.get<LlmConfig[]>("/api/v1/llm-configs"),
    enabled: queryEnabled,
  });

  const { data: myCampaignsRaw } = useQuery<unknown>({
    queryKey: ["campaigns", "my-list"],
    queryFn: () => http.get<unknown>("/api/v1/campaigns?limit=50"),
    enabled: queryEnabled,
    staleTime: 60_000,
  });

  // const { data: senderIdentitiesRaw = [] } = useQuery<SenderIdentity[]>({
  //   queryKey: ["sender-identities"],
  //   queryFn: () =>
  //     http.get<SenderIdentity[]>("/api/v1/sender-identities").then((r) =>
  //       Array.isArray(r) ? r : (r as any)?.items ?? []
  //     ),
  //   enabled: queryEnabled,
  // });

  const { data: checklist } = useQuery<ChecklistData>({
    queryKey: ["onboarding-checklist"],
    queryFn: () => http.get<ChecklistData>("/api/v1/onboarding/checklist"),
    enabled: queryEnabled,
  });

  const agg = (dashRaw as any)?.aggregation ?? null;
  // const topCampaigns: Array<{
  //   id: string;
  //   name: string;
  //   status: string;
  //   replyRate?: number | null;
  // }> = (dashRaw as any)?.topCampaigns ?? [];

  const userName: string | undefined = (dashRaw as any)?.user_name ?? undefined;

  const hasActiveLlm = llmConfigsRaw.some(
    (c) => (c as any).is_active === true || c.isActive === true
  );

  const totalProspects: number = agg?.totalProspects ?? 0;
  const activeCampaigns: number = agg?.activeCampaigns ?? 0;
  // const emailsSentThisWeek: number = agg?.sentThisWeek ?? 0;
  const avgReplyRate: number = agg?.averageReplyRate ?? 0;

  const myCampaignsList: Array<{
    id: string;
    name: string;
    status: string;
    prospect_count?: number;
  }> = (() => {
    if (!myCampaignsRaw) return [];
    const items = Array.isArray(myCampaignsRaw)
      ? myCampaignsRaw
      : ((myCampaignsRaw as any).items ?? []);
    return (items as any[]).map((c) => ({
      id: c.id,
      name: c.name,
      status: c.status,
      // prospect_count: c.prospect_count ?? c.prospectCount ?? undefined,
      prospect_count: c._count?.prospects ?? c.prospect_count ?? c.prospectCount ?? undefined,
    }));
  })();
  const activeCampaignCount = myCampaignsList.filter(
    (c) => c.status?.toLowerCase() === "active"
  ).length;

  // const defaultIdentity = senderIdentitiesRaw.find((s) => s.isDefault) ?? senderIdentitiesRaw[0];
  // const senderTotal = senderIdentitiesRaw.length;

  const timeSeriesPoints: Array<{ date: string; sent: number; replied: number }> =
    (dashRaw as any)?.timeSeries?.points ?? [];
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  const chartData = timeSeriesPoints
    .filter((p) => new Date(p.date) >= sevenDaysAgo)
    .map((p) => ({
      date: new Date(p.date).toLocaleDateString("en-US", { weekday: "short" }),
      Sent: p.sent,
      Replies: p.replied,
    }));

  // All-time emails sent — sourced from backend DashboardAggregation.totalEmailsSent
  // (count of all Sequence rows where sentAt is set, no date filter).
  const totalEmailsSent: number = agg?.totalEmailsSent ?? 0;

  const repliesThisWeek: number = agg?.repliesThisWeek ?? 0;
  // HIDDEN FOR NOW — restore when Meetings/Pipeline cards return
  // const meetingsThisWeek: number = agg?.meetingsThisWeek ?? 0;
  // const pipelineValue: number = agg?.pipelineValue ?? 0;

  const quota = (() => {
    if (!quotaData) return null;
    const q = quotaData as any;
    const bindingLimit: number =
      q.effective_daily_quota ?? q.daily_quota ?? 100;
    return {
      ...q,
      daily_quota: bindingLimit,
      remaining: q.remaining ?? Math.max(0, bindingLimit - (q.emails_sent ?? 0)),
    };
  })();

  // const quotaSource: string = (quotaData as any)?.quota_source ?? "identity";

  const quotaPct = quota
    ? Math.round((quota.emails_sent / Math.max(quota.daily_quota, 1)) * 100)
    : 0;

  if (dashLoading) {
    return (
      <div className="space-y-6 p-6">
        <Skeleton className="h-8 w-48" />
        <div className="grid grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-24 rounded-xl" />
          ))}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Skeleton className="h-56 rounded-xl" />
          <Skeleton className="h-56 rounded-xl" />
        </div>
        <Skeleton className="h-40 rounded-xl" />
      </div>
    );
  }

  if (dashError) {
    return (
      <ErrorState
        title="Dashboard failed to load"
        description={
          (dashErr as { message?: string })?.message ??
          "Could not reach the backend. Check your connection."
        }
        onRetry={refetchDash}
      />
    );
  }

  /* ════════════════════════════════════════════════════════════════════════ */
  /*  Render                                                                  */
  /* ════════════════════════════════════════════════════════════════════════ */

  return (
    <div className="space-y-6">
      <PageHeader
        live
        title={`Welcome back${userName ? `, ${userName.split(" ")[0]}` : ""}`}
        description="Your outreach command center"
      />

      {/* ── LLM Warning Banner ───────────────────────────────────────────── */}
      {!hasActiveLlm && (
        <Card className="border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800">
          <CardContent className="p-4 flex items-center gap-4">
            <AlertCircle className="h-5 w-5 text-amber-600 shrink-0" />
            <div className="flex-1">
              <p className="font-medium text-sm text-amber-900 dark:text-amber-200">
                No LLM configured yet
              </p>
              <p className="text-xs text-amber-700 dark:text-amber-400">
                Connect an AI model to start generating personalized outreach emails.
              </p>
            </div>
            <Button
              size="sm"
              onClick={() => navigate("/setup/llm-models")}
              className="shrink-0"
            >
              <Plus className="h-4 w-4 mr-1" />
              Configure LLM
            </Button>
          </CardContent>
        </Card>
      )}

      {/* ── Stat Cards — Row 1 (top 3) ───────────────────────────────────── */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          {
            label: "Total Prospects",
            value: totalProspects.toLocaleString(),
            icon: <Users className="h-4 w-4" />,
            colorCls: "text-emerald-600 bg-emerald-50 dark:bg-emerald-950/40",
          },
          {
            label: "Active Campaigns",
            value: activeCampaigns.toLocaleString(),
            icon: <PlayCircle className="h-4 w-4" />,
            colorCls: "text-blue-600 bg-blue-50 dark:bg-blue-950/40",
          },
          {
            label: "Emails Sent",
            value: totalEmailsSent.toLocaleString(),
            icon: <Send className="h-4 w-4" />,
            colorCls: "text-violet-600 bg-violet-50 dark:bg-violet-950/40",
          },
        ].map((s) => (
          <Card key={s.label}>
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className={cn("p-2 rounded-lg", s.colorCls)}>{s.icon}</div>
                <div>
                  <p className="text-2xl font-bold leading-tight">{s.value}</p>
                  <p className="text-xs text-muted-foreground">{s.label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* ── Stat Cards — Row 2 (bottom 3) ────────────────────────────────── */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* Avg Reply Rate */}
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className={cn("p-2 rounded-lg", "text-rose-600 bg-rose-50 dark:bg-rose-950/40")}>
                <MessageSquare className="h-4 w-4" />
              </div>
              <div>
                <p className="text-2xl font-bold leading-tight">{fmtPct(avgReplyRate)}</p>
                <p className="text-xs text-muted-foreground">Avg Reply Rate</p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Replies (7d) */}
        <StatCard
          label="Replies (7d)"
          value={repliesThisWeek.toLocaleString()}
          icon={<Reply className="h-4 w-4" />}
        />

        {/* HIDDEN FOR NOW
        <StatCard
          label="Meetings Booked (7d)"
          value={meetingsThisWeek.toLocaleString()}
          icon={<CalendarCheck className="h-4 w-4" />}
        />
        <StatCard
          label="Pipeline Value"
          value={formatCurrency(pipelineValue)}
          icon={<TrendingUp className="h-4 w-4" />}
        />
        */}

        {/* Email Quota Today */}
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-muted-foreground">Quota Today</p>
              <Mail className="h-4 w-4 text-muted-foreground" />
            </div>
            {quota ? (
              <>
                <p className={cn(
                  "mt-2 text-2xl font-bold",
                  quotaPct >= 90
                    ? "text-red-500"
                    : quotaPct >= 70
                    ? "text-amber-500"
                    : "text-foreground"
                )}>
                  {quota.emails_sent.toLocaleString()}
                  <span className="text-sm font-normal text-muted-foreground">
                    {" "}/ {quota.daily_quota.toLocaleString()}
                  </span>
                </p>
                <Progress
                  value={quotaPct}
                  className={cn(
                    "mt-2 h-1.5",
                    quotaPct >= 90
                      ? "[&>div]:bg-rose-500"
                      : quotaPct >= 70
                      ? "[&>div]:bg-amber-500"
                      : "[&>div]:bg-primary"
                  )}
                />
                <p className="mt-1 text-xs text-muted-foreground">
                  {quota.remaining.toLocaleString()} remaining
                </p>
              </>
            ) : (
              <p className="mt-2 text-2xl font-bold text-muted-foreground">—</p>
            )}
          </CardContent>
        </Card>
      </div>

      {/* ── My Campaigns + 7-Day Activity (side by side) ─────────────────── */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        {/* My Campaigns — left col */}
        <Card className="flex flex-col">
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center justify-between">
              <span>My Campaigns</span>
              <Badge variant="secondary">{activeCampaignCount} active</Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0 flex-1">
            {!myCampaignsList.length ? (
              <EmptyState
                title="No campaigns yet"
                description="Create your first campaign to start sending outreach."
                action={
                  <Button size="sm" onClick={() => navigate("/outreach/campaigns")}>
                    Create Campaign
                  </Button>
                }
              />
            ) : (
              /* Scrollable wrapper — shows 6 rows (each ~44px) then scrolls */
              <div className="overflow-y-auto" style={{ maxHeight: "264px" }}>
                <Table>
                  <TableHeader className="sticky top-0 bg-card z-10">
                    <TableRow>
                      <TableHead>Name</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead className="text-right">Prospects</TableHead>
                      <TableHead />
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {myCampaignsList.map((c) => (
                      <TableRow key={c.id}>
                        <TableCell className="font-medium">{c.name}</TableCell>
                        <TableCell>
                          <Badge variant={statusVariant(c.status)}>
                            {CAMPAIGN_STATUS_LABEL[c.status] ?? toProperCase(c.status)}
                          </Badge>
                        </TableCell>
                        <TableCell className="text-right">
                          {c.prospect_count?.toLocaleString() ?? "—"}
                        </TableCell>
                        <TableCell className="w-8">
                          <Button
                            variant="ghost"
                            size="icon"
                            className="h-7 w-7"
                            onClick={() => navigate(`/outreach/campaigns/${c.id}`)}
                          >
                            <ChevronRight className="h-4 w-4" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </CardContent>
        </Card>

        {/* 7-Day Activity chart — right col */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">7-Day Activity</CardTitle>
            <CardDescription>Emails sent vs replies</CardDescription>
          </CardHeader>
          <CardContent>
            {chartData.length === 0 ? (
              <div className="h-48 flex items-center justify-center text-sm text-muted-foreground">
                No activity data yet
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={chartData} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
                  <XAxis
                    dataKey="date"
                    tick={{ fontSize: 11 }}
                    tickLine={false}
                    axisLine={false}
                  />
                  <YAxis tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
                  <Tooltip />
                  <Bar dataKey="Sent" fill="#6366f1" radius={[3, 3, 0, 0]} />
                  <Bar dataKey="Replies" fill="#10b981" radius={[3, 3, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            )}
          </CardContent>
        </Card>

      </div>

      {/* ── Onboarding checklist ─────────────────────────────────────────── */}
      {checklist && !checklist.all_done && (
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center justify-between">
              <span>Getting Started</span>
              <span className="text-sm font-normal text-muted-foreground">
                {checklist.completed}/{checklist.total} complete
              </span>
            </CardTitle>
            <Progress
              value={Math.round((checklist.completed / checklist.total) * 100)}
              className="h-1.5 mt-1"
            />
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {checklist.items
                .sort((a, b) => a.order - b.order)
                .map((item) => (
                  <div
                    key={item.key}
                    className={cn(
                      "flex items-start gap-3 p-2.5 rounded-lg transition-colors",
                      item.done ? "opacity-50" : "hover:bg-accent cursor-pointer"
                    )}
                    onClick={() => !item.done && navigate(item.link)}
                  >
                    <div
                      className={cn(
                        "mt-0.5 h-4 w-4 rounded-full border-2 shrink-0 flex items-center justify-center",
                        item.done
                          ? "border-primary bg-primary"
                          : "border-muted-foreground"
                      )}
                    >
                      {item.done && (
                        <svg
                          className="h-2.5 w-2.5 text-primary-foreground"
                          viewBox="0 0 10 10"
                          fill="none"
                        >
                          <path
                            d="M2 5l2.5 2.5L8 3"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <div>
                      <p className="text-sm font-medium">{item.label}</p>
                      <p className="text-xs text-muted-foreground">{item.description}</p>
                    </div>
                  </div>
                ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* ── Sender Identity — HIDDEN (Sender Identities moved to Admin, currently disabled) ── */}
      {/* {senderTotal > 0 && (
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center gap-2">
              <Users2 className="h-4 w-4" />
              Sender Identity
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm">
              <span className="text-muted-foreground">Default: </span>
              <span className="font-medium font-mono text-sm">
                {defaultIdentity?.email ?? "—"}
              </span>
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              {senderTotal} identit{senderTotal === 1 ? "y" : "ies"} configured
            </p>
            <Button
              variant="outline"
              size="sm"
              className="mt-3"
              onClick={() => navigate("/setup/sender-identities")}
            >
              Manage Identities
            </Button>
          </CardContent>
        </Card>
      )} */}

      {/* ── Quick Actions (full-width) ───────────────────────────────────── */}
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Quick Actions</CardTitle>
          <CardDescription>Jump to any part of the platform</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-6 gap-2">
            {QUICK_ACTIONS.map((action) => {
              const Icon = action.icon;
              return (
                <button
                  key={action.label}
                  onClick={() => navigate(action.path)}
                  className="flex flex-col items-center gap-1.5 p-2.5 rounded-lg border border-border hover:bg-accent transition-colors text-center"
                >
                  <Icon className="h-4 w-4 text-muted-foreground" />
                  <span className="text-xs leading-tight">{action.label}</span>
                </button>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* ── 8-Step AI Outreach Workflow Guide (top 4 + bottom 4) ─────────── */}
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base">AI Outreach Workflow</CardTitle>
          <CardDescription>
            Follow these steps from setup to tracked replies
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {WORKFLOW_STEPS.map((s) => (
              <button
                key={s.step}
                onClick={() => navigate(s.path)}
                className="flex items-start gap-3 p-3 rounded-lg border border-border hover:bg-accent transition-colors text-left"
              >
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-bold">
                  {s.step}
                </div>
                <div>
                  <p className="text-sm font-medium">{s.title}</p>
                  <p className="text-xs text-muted-foreground">{s.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}